import { render, staticRenderFns } from "./territoryManagement.vue?vue&type=template&id=432fe5d3"
import script from "./territoryManagement.vue?vue&type=script&lang=js"
export * from "./territoryManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports